import { AccountTaskType } from 'src/app/types/task';
import { AccountTaskService } from 'src/app/services/account/account-task.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SeatingSettingService } from 'src/app/services/seating/seating-setting.service';

import { AccountEventModeService } from 'src/app/services/account/account-event-mode.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-account-task',
  templateUrl: './account-task.page.html',
  styleUrls: ['./account-task.page.scss'],
})
export class AccountTaskPage implements OnInit, OnDestroy {

  privilege: { [ task: string] : boolean; };
  status: { [ task: string] : boolean; };
  seatingTypeName: string;
  private accountTaskSubscription: Subscription;
  private pendingTaskSubscription: Subscription;

  constructor(
    private accountEventModeService: AccountEventModeService,
    private accountTaskService: AccountTaskService,
    private seatingSettingService: SeatingSettingService,
  ) { }

  ngOnInit() {}

  ngOnDestroy(): void {
    this.unwatch();
  }

  ionViewWillEnter() {
    this.watch();
    this.seatingTypeName = this.getSeatingTypeName();
  }

  ionViewWillLeave() {
    this.unwatch();
  }

  watch() {
    this.watchAccountTask();
    this.watchPendingTask();
  }

  unwatch() {
    this.unwatchAccountTask();
    this.unwatchPendingTask();
  }

  watchAccountTask() {
    if (!this.accountTaskSubscription) {
      this.accountTaskSubscription = this.accountTaskService.observableAccountTask.subscribe(() => {
        this.setup();
      })
    }
  }

  unwatchAccountTask() {
    if (this.accountTaskSubscription) {
      this.accountTaskSubscription.unsubscribe();
      this.accountTaskSubscription = null;
    }
  }

  watchPendingTask() {
    if (!this.pendingTaskSubscription) {
      this.pendingTaskSubscription = this.accountTaskService.observablePending.subscribe(() => {
        this.setup();
      });
    }
  }

  unwatchPendingTask() {
    if (this.pendingTaskSubscription) {
      this.pendingTaskSubscription.unsubscribe();
      this.pendingTaskSubscription = null;
    }
  }

  setup() {
    this.privilege = {
      'setup_visitor_page': this.checkChecklistPrivilege('setup_visitor_page'),
      'add_guest': this.checkChecklistPrivilege('add_guest'),
      'send_qr': this.checkChecklistPrivilege('send_qr'),
      'invite_member': this.checkChecklistPrivilege('invite_member'),
      'assign_seating': this.checkChecklistPrivilege('assign_seating'),
      'review_setting': this.checkChecklistPrivilege('review_setting'),
      'checkin_guest': this.checkChecklistPrivilege('checkin_guest'),
      'record_gift': this.checkChecklistPrivilege('record_gift'),
    };

    this.status = {
      'setup_visitor_page': this.checkChecklistStatus('setup_visitor_page'),
      'add_guest': this.checkChecklistStatus('add_guest'),
      'send_qr': this.checkChecklistStatus('send_qr'),
      'invite_member': this.checkChecklistStatus('invite_member'),
      'assign_seating': this.checkChecklistStatus('assign_seating'),
      'review_setting': this.checkChecklistStatus('review_setting'),
      'checkin_guest': this.checkChecklistStatus('checkin_guest'),
      'record_gift': this.checkChecklistStatus('record_gift'),
    };
  }

  checkChecklistPrivilege(accountTaskType: AccountTaskType): boolean {
    return this.accountTaskService.checkChecklistPrivilege(accountTaskType);
  }

  checkChecklistStatus(accountTaskType: AccountTaskType): boolean {
    return this.accountTaskService.checkChecklistStatus(accountTaskType);
  }

  goChecklistAction(accountTaskType: AccountTaskType) {
    this.accountTaskService.goChecklistAction(accountTaskType);
  }

  goChecklistHelp(accountTaskType: AccountTaskType) {
    this.accountTaskService.goChecklistHelp(accountTaskType);
  }

  getSeatingTypeName(): string {
    return this.seatingSettingService.getSeatingTypeName();
  }

  replaceEventType(text: string) {
    return this.accountEventModeService.replaceEventType(text);
  }

}
